import { Component } from "@angular/core";

@Component({
  selector: "loginnavigator-page",
  templateUrl: "./Loginnavigator.page.html",styleUrls: ["../app.component.css"]
})
export class LoginNavPage {
    title:"LoginNav"
}